<div class="sliderContainer">
	@if (!editable) {
		<div class="valueIfNotEdit" [@flyInOut]="load_completed">Value: {{ value }}</div>
	}

	<mat-slider color="accent" [disabled]="!editable" discrete [max]="max" [min]="min" [step]="step">
		<input matSliderThumb [value]="value" (valueChange)="onValueChanged.emit($event)" />
	</mat-slider>

	<div class="minLabel">MIN: {{ min }}</div>

	<div class="maxLable">MAX: {{ max }}</div>
</div>
